// import { CALL_API } from 'Middlewares'
import {
	SET_ERROR,
	SET_LOADING
} from '../types'


export function setError(errorList, newError, isShow) {
	let mapError = []
	if (errorList && Array.isArray(errorList)) {
		if (isShow === true) {
			errorList.forEach(e => {
				mapError.push({ ...e, isShow: true })
			});
		} else {
			mapError = mapError.concat(errorList)
		}
	}
	if (newError) {
		mapError.push({ ...newError, isShow: false })
	}
	return {
		type: SET_ERROR,
		error: mapError
	}
}

export function setLoading(isLoading) {
	return {
		type: SET_LOADING,
		isLoading: isLoading
	}
}


// WEBPACK FOOTER //
// ./src/app/redux/actions/actionsCallAPI.js